import unauthenticatedHttp from "@/services/unauthenticatedHttp";
import { telemetryRequestBody } from "@/services/unauthService/types";

export function postTelemetries(data: any) {
  try {
    telemetryRequestBody.parse(data);
  } catch {
    // Malformed telemetry payload - drop it rather than sending a request we know will fail
    return Promise.resolve();
  }

  return unauthenticatedHttp()
    .post(`${globalThis.env.API_UNAUTH}/telemetry`, data)
    .catch(() => {
      // Ignore telemetry errors
    });
}
